import { Drawer } from "@xola/ui-kit";
import { Loader } from "common";
import React from "react";
import { Permission, Traveler, UserType } from "types";
import { useCollection } from "../../../hooks/useCollection";
import { ContactDetails } from "../../Customers/Contacts/ContactDetails";
import { useTraveler } from "@/hooks/resources/useTraveler";
import { useAuthorization } from "@/hooks/useAuthorization";

interface PurchaseContactInfoDrawerProps {
    travelerId?: ID;
    isOpen: boolean;
    onClose: () => void;
}

export const PurchaseContactInfoDrawer = ({ isOpen, travelerId, onClose }: PurchaseContactInfoDrawerProps) => {
    /**
     * We are using `/api/users` instead of `/api/users/:id because `/users/:id` does not return the `isOrganizer`
     * flag. Because of this missing flag we cannot show the appropriate flag in purchase summary and contacts page
     * Ideal solution: API team updates logic to return the same values from /users/:id and /users?search=id
     */
    const { isGranted } = useAuthorization();

    const { traveler } = useTraveler(travelerId, null, {
        enabled: isGranted(Permission.MODIFY_PURCHASE_CONTACT_VIEW),
    });

    const { data: contacts, isLoading } = useCollection<Traveler>("users", {
        search: travelerId,
        type: UserType.TRAVELER,
        limit: 1, // Because we know that a user always exists with this ID
    });
    const contact = contacts?.[0];

    return (
        <Drawer
            size="xl"
            classNames={{ dialog: "z-30" }}
            isOpen={isOpen}
            content={isLoading ? <Loader /> : <ContactDetails contact={{ ...traveler, ...contact }} />}
            onClose={onClose}
        />
    );
};
